import React, { useEffect } from 'react';
import { useTitle } from "../../../contexts/title";
import MaterialCostSearch from '../../../features/common/material-cost/components/MaterialCostSearch';

export default function MaterialCostPage() {

	const pageTitle = useTitle();
	useEffect(() => {
		pageTitle.setTitle('Material Cost')
	}, [pageTitle]);

	return (
		<React.Fragment>
			<div className={'content-block'}>
				<MaterialCostSearch />
			</div>
		</React.Fragment>
	)
} 
